import {
  Box, Grid, Typography,
} from '@mui/material';
import React from 'react';
import { Container } from './styles';
import DataRangePicker from 'components/DataRangePicker';
import CardInfo from 'components/CardInfo';

function Dashboard({
  title, totals, children, dateRange, setDateRange, loading,
}) {
  return (
    <Box pb={4}>
      <Container
        p={2}
        borderRadius={4}
        bgcolor="white"
        boxShadow="0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)"
      >
        <Grid container spacing={4}>
          <Grid item alignSelf="center"><Typography fontSize={22}>{title}</Typography></Grid>
          <Grid item maxWidth={250} width="100%">
            <DataRangePicker dateRange={dateRange} inputLabel="Filtrar por período" setDateRange={setDateRange} />
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs>
            <CardInfo loading={loading} title="Receita" value={totals.income} />
          </Grid>
          <Grid item xs>
            <CardInfo loading={loading} title="Despesas" value={totals.expenses} />
          </Grid>
          <Grid item xs>
            <CardInfo loading={loading} title="Lucro" value={totals.profit} />
          </Grid>
        </Grid>
      </Container>
      <Box mt="-30px" mb="-30px">
        {/* Adicionar componente de tabela como filho */}
        {children}
      </Box>
    </Box>
  );
}

export default Dashboard;
